import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, User, Eye, EyeOff } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card } from '../components/ui/card';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

export const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const result = await login(formData.username, formData.password);
    
    if (result.success) {
      toast.success('Login successful!');
      navigate('/admin/dashboard');
    } else {
      toast.error(result.error || 'Invalid credentials');
    }
    
    setIsSubmitting(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FAF9F7] to-[#F5F3F0] flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-white border-none shadow-2xl p-8">
        <div className="text-center mb-8">
          <div className="bg-[#F5F3F0] w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <Lock className="h-8 w-8 text-[#C4B5A0]" />
          </div>
          <h1 className="text-3xl font-seasons text-[#2C2C2C] mb-2">Admin Login</h1>
          <p className="text-[#8B7D6B] font-montserrat text-sm">Sachdeva Sons - Admin Panel</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-montserrat text-[#6B4E37] mb-2">
              Username
            </label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-[#8B7D6B]" />
              <Input
                type="text"
                value={formData.username}
                onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                required
                className="pl-10 bg-[#F5F3F0] border-none focus:ring-2 focus:ring-[#C4B5A0]"
                placeholder="Enter username"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-montserrat text-[#6B4E37] mb-2">
              Password
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-[#8B7D6B]" />
              <Input
                type={showPassword ? 'text' : 'password'}
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
                className="pl-10 pr-10 bg-[#F5F3F0] border-none focus:ring-2 focus:ring-[#C4B5A0]"
                placeholder="Enter password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#8B7D6B] hover:text-[#C4B5A0]"
              >
                {showPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
              </button>
            </div>
          </div>

          <Button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-[#C4B5A0] hover:bg-[#B0A090] text-white font-montserrat tracking-wider uppercase py-6 transition-all duration-300 hover:shadow-lg"
          >
            {isSubmitting ? 'Logging in...' : 'Login'}
          </Button>
        </form>

        <div className="mt-6 text-center">
          <button
            onClick={() => navigate('/')}
            className="text-sm text-[#8B7D6B] hover:text-[#C4B5A0] font-montserrat transition-colors"
          >
            ← Back to Website
          </button>
        </div>
      </Card>
    </div>
  );
};